import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#FFDA44\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#338AF3\" d=\"M11.999 24c3.637 0 6.896-1.618 9.097-4.174H2.902A11.97 11.97 0 0 0 12 24M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 1.083.144 2.132.413 3.13h23.174c.269-.998.413-2.047.413-3.13M.953 16.696q.348.817.808 1.566h20.477q.46-.75.808-1.566z\"></path><path fill=\"#F0F0F0\" d=\"M5.5 7.57 3.157 6.533 5.501 5.5l1.034-2.345L7.57 5.5l2.345 1.034L7.57 7.57 6.535 9.914z\"></path><path fill=\"#D80027\" d=\"m6.532 4.447.64 1.448 1.447.64-1.448.638-.639 1.448-.639-1.448-1.448-.639 1.448-.639z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }